import Select, { MultiValue, SingleValue } from 'react-select';
import { tPaymentMethodOption } from '../../SubscriptionManager.types';
import { useSubscriptionManagerContext } from '../../SubscriptionManager.context';
import { isUndefined } from 'lodash';
import CardSelectorOption from './Option.component';
import CardSelectorSelectedValue from './SelectedValue.component';

function CardSelector() {
  const {
    selectedPaymentMethod,
    paymentMethodsOptions,
    loadingPaymentMethodRequest,
    setSelectedPaymentMethodOnClick,
    paymentMethods,
  } = useSubscriptionManagerContext();

  const handleChange = (
    newValue:
      | MultiValue<tPaymentMethodOption>
      | SingleValue<tPaymentMethodOption>,
  ) => {
    const paymentMethodSelection = paymentMethods.find(
      (method) =>
        method.paymentMethodId === (newValue as tPaymentMethodOption).value,
    );
    if (isUndefined(paymentMethodSelection)) {
      return;
    }
    setSelectedPaymentMethodOnClick(true, paymentMethodSelection);
  };

  return (
    <Select
      options={paymentMethodsOptions}
      components={{
        Option: CardSelectorOption,
        SingleValue: CardSelectorSelectedValue,
      }}
      id="paymentMethods"
      name="paymentMethods"
      isLoading={loadingPaymentMethodRequest}
      value={
        {
          value: selectedPaymentMethod.paymentMethodId,
          brand: selectedPaymentMethod.brand,
          lastDigits: selectedPaymentMethod.lastDigits,
        } as tPaymentMethodOption
      }
      onChange={handleChange}
    />
  );
}

export default CardSelector;
